import angular from "angular";
import { extendModule } from "ng";
import PromotionEdit from "emun.promotion/promotion-edit";
import VendorPromotions from "emun.promotion/vendor-promotions";
import PromotionsList from "emun.promotion/promotions-list";
import promotionsModule from "emun.promotion/promo-sheet/promo-sheets.module";

const dependencies = [
  "emun.auth",
  "webutils",
  "webforms",
  "webmodals",
  "ui.router"
];

export const app = angular
  .module("emun.promotion", dependencies)
  .component("promotionEdit", PromotionEdit)
  .component("promotionsList", PromotionsList)
  .component("vendorPromotions", VendorPromotions);

extendModule(app, promotionsModule);

export default app.name;
